module.exports = __webpack_public_path__ + "static/media/life.5345ba7a.mp3";